module.exports = __webpack_public_path__ + "media/images/lb/481-dee43b919c5b9e463a5ff6d0317928c4.svg";